// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"rio2016-2XROF rio2016-253MP","panels":"rio2016-15fRG","panel":"rio2016-3TZF5","copy":"rio2016-XnAa_","copyMain":"rio2016-2m1Kq rio2016-XnAa_","copyAside":"rio2016-3WLBh rio2016-KJQB4 rio2016-XnAa_"};


/*****************
 ** WEBPACK FOOTER
 ** ./styles/chrome.css
 ** module id = 76
 ** module chunks = 0 2 3 4
 **/